var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.266 16.343v1.502c0 1.063-1.049 1.177-1.417 1.177a1.15 1.15 0 0 1-1.276-1.177v-1.417H3v-4.125c0-2.111 1.573-2.352 1.573-2.352l1.418-3.36a2.24 2.24 0 0 1 2.281-1.587h7.441a2.24 2.24 0 0 1 2.282 1.588l1.418 3.359S21 10.19 21 12.303v4.125h-1.573v1.417a1.148 1.148 0 0 1-1.276 1.177c-.283 0-1.417-.114-1.417-1.177v-1.502zm12.36-3.756a1.32 1.32 0 0 0-1.333-1.304 1.318 1.318 0 0 0 0 2.622 1.333 1.333 0 0 0 1.332-1.318M18.093 9.88s-.68-1.786-.963-2.551c-.284-.766-.525-1.092-1.616-1.092H8.627c-1.092 0-1.418.326-1.63 1.092-.213.765-.964 2.55-.964 2.55zM5.82 13.905a1.318 1.318 0 1 0-1.318-1.318 1.33 1.33 0 0 0 1.318 1.318",
    clipRule: "evenodd"
  })));
};
export default SvgCar;